module.exports = __webpack_public_path__ + "static/media/wheel-vector.2c231eb2.svg";